import gql from "graphql-tag"

const SEARCH_DISCOUNT_CODE_RULES = gql`
  query searchDiscountCodeRule(
    $from: Int!
    $size: Int!
    $sort: [SearchSorting!]
    $query: AWSJSON
  ) {
    searchDiscountCodeRules(
      from: $from
      size: $size
      sort: $sort
      query: $query
    ) {
      total
      hits {
        id
        name
        isActive
        validFrom
        validTo
        created
        isStackable
        isExclusive
        applyLast
        sortOrder
        updated
      }
    }
  }
`

export default SEARCH_DISCOUNT_CODE_RULES
